import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';
import { LOADING, COMPLETE, INVOICES_GET_OK } from './types';
import { call } from './../utilities/http';

const defaultState = {
    list: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case INVOICES_GET_OK:
            return { ...state, list: action.data };

        default:
            return state;
    }
}

export function getInvoices(role, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getInvoices'} defaultMessage={'Unable to retrieve invoices.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        const { id, type } = role;
        if (!id || !type) {
            Snackbar.error(errorMessage);
            dispatch({ type: COMPLETE });
            return;
        }

        call({ path: `/${type}/${id}/invoices` })
            .then(response => {
                dispatch({ type: INVOICES_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getInvoiceDetails(invoiceId, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getInvoiceTimesheets'} defaultMessage={'Unable to retrieve invoice with timesheets.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/invoice/${invoiceId}/` })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function generatePDFDocument(invoice, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.generatePDFDocument'} defaultMessage={'Unable to generate pdf document.'} />;

    const body = {
        blank_ref_id: invoice.admin_id,
        blank_ref_type: 'admin',
        doc_type: 'invoice',
        output_ref_id: invoice.client_id,
        output_ref_type: 'client'
    };

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/invoice/${invoice.id}/make_pdf`, method: 'POST', body })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function generateClientInvoice(clientId, dueDate, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.generateClientInvoice'} defaultMessage={'Unable to generate Invoice.'} />;
    let successMessage = <FormattedMessage id={'success.generateClientInvoice'} defaultMessage={'Client Invoice successfully generated.'} />;

    const body = {
        resource_type: 'client',
        type: 'invoice',
        resource_id: clientId,
        due_date: dueDate
    };

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/transfer/generate`, method: 'POST', body })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
                Snackbar.success(successMessage);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/invoices.jsx